const LG = 1024;
const desktopQuery = window.matchMedia(`(min-width: ${LG}px)`);

function init(section) {
    const searchInput = section.querySelector('[data-search]');
    const clearBtn = section.querySelector('[data-search-clear]');
    const resultCount = section.querySelector('[data-result-count]');
    const blockEls = Array.from(section.querySelectorAll('.our-work-block'));
    const filterBtns = Array.from(section.querySelectorAll('[data-filter]'));

    const filters = { sector: [], service: [] };

    // Internal state for each block
    const state = blockEls.map((el, i) => ({
        el,
        index: i,
        isStat: el.dataset.blockType === 'stat_panel',
        title: (el.dataset.title || '').toLowerCase(),
        sectors: (el.dataset.sectors || '').split(',').map(s => s.trim()),
        services: (el.dataset.services || '').split(',').map(s => s.trim()),
        visible: true,
    }));

    const projectBlocks = state.filter(b => !b.isStat);

    // Assign view-transition-name to each block
    blockEls.forEach((el, i) => {
        el.style.viewTransitionName = `work-block-${i}`;
    });

    // --- Filtering ---

    function computeVisibility() {
        const search = (searchInput?.value || '').toLowerCase();

        state.forEach(b => {
            let visible = true;
            if (search && !b.title.includes(search)) visible = false;
            if (visible && filters.sector.length > 0) {
                if (!b.sectors.some(s => filters.sector.includes(s))) visible = false;
            }
            if (visible && filters.service.length > 0) {
                if (!b.services.some(s => filters.service.includes(s))) visible = false;
            }
            b.visible = visible;
        });
    }

    function applyFilters() {
        clearExpand();
        computeVisibility();
        computeRows();

        let count = 0;
        state.forEach(b => {
            b.el.style.display = b.visible ? '' : 'none';
            if (b.visible && !b.isStat) count++;
        });
        if (resultCount) resultCount.textContent = count;

        filterBtns.forEach(btn => {
            const type = btn.dataset.filter;
            const value = btn.dataset.filterValue;
            if (value === undefined) {
                btn.classList.toggle('active', filters[type].length === 0);
            } else {
                btn.classList.toggle('active', filters[type].includes(value));
            }
        });
    }

    function applyFiltersAnimated() {
        if (!document.startViewTransition) return applyFilters();
        document.startViewTransition(() => applyFilters());
    }

    function toggleFilter(type, value) {
        if (value === undefined) {
            filters[type] = [];
        } else if (filters[type].includes(value)) {
            filters[type] = filters[type].filter(v => v !== value);
        } else {
            filters[type].push(value);
        }
        applyFiltersAnimated();
    }

    // --- Rows ---

    let rows = [];

    function computeRows() {
        const visible = state.filter(b => b.visible);
        rows = [];
        for (let i = 0; i < visible.length; i += 2) {
            const row = [visible[i]];
            if (visible[i + 1]) row.push(visible[i + 1]);
            rows.push(row);
        }

        console.log('rows', rows.map(r => r.map(b => `${b.isStat ? 'STAT' : b.title} [${b.index}]`)));
        return rows;
    }

    function findRowOf(block) {
        return rows.find(row => row.includes(block));
    }

    // --- Expand / Collapse ---

    function clearExpand() {
        blockEls.forEach(el => el.classList.remove('active', 'collapsed'));
    }

    function toggleBlock(e, block) {
        const wasActive = block.el.classList.contains('active');

        if (wasActive && e.target.closest('.info-panel')) return;

        clearExpand();

        if (!wasActive) {
            block.el.classList.add('active');

            if (desktopQuery.matches) {
                const row = findRowOf(block);
                if (row) {
                    row.forEach(b => {
                        if (b !== block) b.el.classList.add('collapsed');
                    });
                }
            }
        }
    }

    // --- Event listeners ---

    searchInput?.addEventListener('input', () => applyFiltersAnimated());
    clearBtn?.addEventListener('click', () => {
        if (searchInput) searchInput.value = '';
        applyFiltersAnimated();
    });

    filterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            toggleFilter(btn.dataset.filter, btn.dataset.filterValue);
        });
    });

    projectBlocks.forEach(block => {
        block.el.addEventListener('click', (e) => toggleBlock(e, block));
    });

    // Initial render
    applyFilters();
}

// Init when DOM is ready
const section = document.querySelector('.our-work-section');
if (section) init(section);
